export let TealiumTrackType = /*#__PURE__*/function (TealiumTrackType) {
  TealiumTrackType["LINK"] = "link";
  TealiumTrackType["VIEW"] = "view";
  return TealiumTrackType;
}({});